<section class="uk-section uk-position-relative" uk-height-viewport>
  <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
    <h3 class="uk-width-expand uk-text-center uk-padding-remove uk-margin-small-left">
      Loading . . .</h3>
  </div>
  <div class="uk-position-bottom-center uk-padding-small">
    <small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
  </div>
  <!-- <app-loader *ngIf="(loader | async)"></app-loader> -->
</section>
<ng-container *ngIf="!(permission_recoding | async)">
  <app-modal-permission></app-modal-permission>
</ng-container>